import { render } from "./News.vue?vue&type=template&id=5e4daafd&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=5e4daafd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5e4daafd"

export default script